import { formatNumberString } from './Utils';

const REGEX = /(D{1,2})|(h{1,2})|(m{1,2})|(s{1,2})/g;

export default class DateUtils {
    public static format(time: number, format: string): string {
        const D = Math.floor(time / (24 * 60 * 60 * 1000));
        let h = Math.floor(time / (60 * 60 * 1000));
        let m = Math.floor(time / (60 * 1000)) % 60;
        let s = Math.floor(time / 1000) % 60;

        return format.replace(REGEX, match => {
            const len = match.length;
            switch (match[0]) {
                case 'D':
                    h = h % 24;
                    return len === 1 ? D.toString() : ('0' + D).slice(-2);
                case 'h':
                    m = m % 60;
                    return len === 1 ? h.toString() : ('0' + h).slice(-2);
                case 'm':
                    s = s % 60;
                    return len === 1 ? m.toString() : ('0' + m).slice(-2);
                case 's':
                    return len === 1 ? s.toString() : ('0' + s).slice(-2);
                default:
                    return match;
            }
        });
    }

    public static elapsedDays(from: number, to: number) {
        return Math.ceil((to - from) / (1000 * 3600 * 24));
    }

    public static timeRemainingTo(time: number, now?: number): number {
        if (now) {
            return time - now;
        }
        return time - Date.now();
    }

    public static secondsToMilliseconds(seconds: number): number {
        return seconds * 1000;
    }

    public static minutesToMilliseconds(minutes: number): number {
        return minutes * DateUtils.secondsToMilliseconds(60);
    }

    public static hoursToMilliseconds(hours: number): number {
        return hours * DateUtils.minutesToMilliseconds(60);
    }

    public static daysToMilliseconds(days: number): number {
        return days * DateUtils.hoursToMilliseconds(24);
    }

    public static getCurrentWeek(): number {
        let date = new Date(Date.now());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
        // January 4 is always in week 1.
        let week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return (
            1 +
            Math.round(
                ((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
            )
        );
    }

    public static getWeekYear(): number {
        var date = new Date(Date.now());
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
        return date.getFullYear();
    }

    public static levelTimeToString(time: number) {
        const minutes = formatNumberString(Math.floor(time / 60), 1);
        const seconds = formatNumberString(Math.round(time % 60));
        const timeText = `${minutes}:${seconds}`;
        return timeText;
    }
}
